// Parse bảng "Candidate Info" dán từ Teams (mỗi dòng = "Label<tab/space>Value").
// Chỉ lấy các field cần cho platform — bỏ nhóm lương theo yêu cầu.
//
// Hàm thuần, có unit test (test/metrics.test.mjs). Trước đây nằm trong
// entry.js cùng code DOM; tách ra để test không phải import file UI.

/** Field đọc được từ ticket → tên field của form Log RTO. */
export type TicketFields = {
  name?: string;
  position?: string;
  level?: string;
  eng?: string;
  source?: string;
  profileLink?: string;
  interviewDate?: string;
  round?: string;
  interviewedBy?: string;
  assessment?: string;
  joiningDate?: string;
  potentialProject?: string;
};

const TICKET_FIELDS: [keyof TicketFields, RegExp][] = [
  ["name", /^name\b/i],
  ["position", /^position\b/i],
  ["level", /^technical level\b/i],
  ["eng", /^eng score(\s*\(elsa\))?/i],
  ["source", /^source\b/i],
  ["profileLink", /^profile link\b/i],
  ["interviewDate", /^interview date\b/i],
  ["round", /^round\b/i],
  ["interviewedBy", /^interviewed by\b/i],
  ["assessment", /^overall assessment\b/i],
  ["joiningDate", /^possible joining date\b/i],
  ["potentialProject", /^potential project\b/i],
];

export function parseCandidateTicket(text: string): TicketFields {
  const out: TicketFields = {};
  for (const raw of String(text).split(/\r?\n/)) {
    const line = raw.trim();
    if (!line) continue;
    for (const [key, re] of TICKET_FIELDS) {
      const m = line.match(re);
      // Dòng đầu tiên khớp một label thì thắng — label lặp lại bị bỏ qua.
      if (m && !(key in out)) {
        const val = line.slice(m[0].length).replace(/^[\s:\-–—|]+/, "").trim();
        if (val) out[key] = val;
      }
    }
  }
  return out;
}
